import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	//<React.StrictMode>
	<App />
	//</React.StrictMode>
);

// Version check and cache clearing
fetch('/version.json')
	.then((res) => res.json())
	.then((data) => {
		const currentVersion = data.cacheVersion;
		const savedVersion = localStorage.getItem('cache_version');

		if (savedVersion !== currentVersion) {
			console.log('New version detected, clearing cache and storage');

			localStorage.clear();
			sessionStorage.clear();

			// Clear cookies
			document.cookie.split(';').forEach((cookie) => {
				document.cookie = cookie
					.replace(/^ +/, '')
					.replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
			});

			localStorage.setItem('cache_version', currentVersion);
			window.location.reload(true);
		}
	})
	.catch((err) => console.error('Version check failed', err));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
